/**
 * Booking URLs with UTM tracking. Defaults to in-app booking route.
 */

const DEFAULT_BOOKING_RETURN_ORIGIN = 'https://www.academyofsquash.com';

function getBookingOriginFromEnv(raw: string | undefined): string | null {
  const value = raw?.trim();
  if (!value) {
    return null;
  }

  try {
    return new URL(value).origin;
  } catch {
    return null;
  }
}

export function getBookingUrl(utmSource: string): string {
  const raw = process.env.NEXT_PUBLIC_BOOKING_URL?.trim();
  if (!raw) {
    return `/book?utm_source=${encodeURIComponent(utmSource)}`;
  }
  try {
    const base = raw.replace(/\/$/, '');
    if (base.startsWith('/')) {
      return `${base}?utm_source=${encodeURIComponent(utmSource)}`;
    }

    const externalUrl = new URL(base);
    externalUrl.searchParams.set('utm_source', utmSource);
    externalUrl.searchParams.set('utm_medium', 'website');
    externalUrl.searchParams.set('utm_campaign', 'aos_booking');
    return externalUrl.toString();
  } catch {
    return `/book?utm_source=${encodeURIComponent(utmSource)}`;
  }
}

export function getBookingReturnBaseUrl(): string {
  const explicitCheckoutOrigin = getBookingOriginFromEnv(
    process.env.STRIPE_CHECKOUT_RETURN_BASE_URL
  );
  if (explicitCheckoutOrigin) {
    return `${explicitCheckoutOrigin}/book`;
  }

  const siteOrigin =
    getBookingOriginFromEnv(process.env.NEXT_PUBLIC_SITE_URL) ?? DEFAULT_BOOKING_RETURN_ORIGIN;
  return `${siteOrigin}/book`;
}
